import { formatDistanceToNow } from 'date-fns';
import { Text } from '@optiaxiom/react';

const formatTimestamp = (timestamp: string) => {
  // Ensure timestamp is treated as UTC by appending 'Z' if not present
  const utcTimestamp = timestamp.endsWith('Z') ? timestamp : timestamp + 'Z';
  const date = new Date(utcTimestamp);

  // Return relative time (e.g., "2 minutes ago")
  return formatDistanceToNow(date, { addSuffix: true });
};

const formatFullTimestamp = (timestamp: string) => {
  // Ensure timestamp is treated as UTC by appending 'Z' if not present
  const utcTimestamp = timestamp.endsWith('Z') ? timestamp : timestamp + 'Z';
  const date = new Date(utcTimestamp);

  // Format as local date and time
  return date.toLocaleString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    timeZoneName: 'short',
  });
};

export function TimeStampCell({ timestamp }: { timestamp: string }) {
  return (
    <Text fontSize="md" title={formatFullTimestamp(timestamp)}>
      {formatTimestamp(timestamp)}
    </Text>
  );
}
